import {Types} from 'mongoose';
import * as dis2 from '../../dispossitions/dispossitions.data';
import {ACTIVITY_TYPE_CMC_EVENTS} from '../activity-type.const';
import {OTHER_FEE} from '../payamnets.data';
import {
    ANNUAL_METTING_ID,
    ANNUAL_METTING_LABEL,
    BOARD_MEETING_ID,
    BOARD_MEETING_LABEL,
    COMMITTEE_MEETING_ID,
    COMMITTEE_MEETING_LABEL,
    EVENTS_ID,
    EVENTS_LABEL,
    ORGANIZATIONAL_EVENTS_ID,
    OTHER_ID,
    OTHER_LABEL,
    STATEGIC_PLANNING_ID,
    STATEGIC_PLANNING_LABEL,
} from './organizational-events.const';

export const BOARD_MEETING = {
    _id: new Types.ObjectId(BOARD_MEETING_ID),
    label: BOARD_MEETING_LABEL,
    defaultDisposition: dis2.OE_BM_OPEN_PENDING,
    dispositions: [dis2.OE_BM_OPEN_PENDING, dis2.OE_BM_COMPLETED, dis2.OE_BM_CANCELLED],
    paymentIn: [OTHER_FEE],
    paymentOut: [OTHER_FEE],
};

export const ANNUAL_METTING = {
    _id: new Types.ObjectId(ANNUAL_METTING_ID),
    label: ANNUAL_METTING_LABEL,
    defaultDisposition: dis2.OE_AM_OPEN_PENDING,
    dispositions: [dis2.OE_AM_OPEN_PENDING, dis2.OE_AM_COMPLETED, dis2.OE_AM_CANCELLED],
    paymentIn: [OTHER_FEE],
    paymentOut: [OTHER_FEE],
};

export const COMMITTEE_MEETING = {
    _id: new Types.ObjectId(COMMITTEE_MEETING_ID),
    label: COMMITTEE_MEETING_LABEL,
    defaultDisposition: dis2.OE_CM_OPEN_PENDING,
    dispositions: [dis2.OE_CM_OPEN_PENDING, dis2.OE_CM_COMPLETED, dis2.OE_CM_CANCELLED],
    paymentIn: [OTHER_FEE],
    paymentOut: [OTHER_FEE],
};

export const STATEGIC_PLANNING = {
    _id: new Types.ObjectId(STATEGIC_PLANNING_ID),
    label: STATEGIC_PLANNING_LABEL,
    defaultDisposition: dis2.OE_SP_OPEN_PENDING,
    dispositions: [dis2.OE_SP_OPEN_PENDING, dis2.OE_SP_COMPLETED, dis2.OE_SP_CANCELLED],
    paymentIn: [OTHER_FEE],
    paymentOut: [OTHER_FEE],
};

export const EVENTS = {
    _id: new Types.ObjectId(EVENTS_ID),
    label: EVENTS_LABEL,
    defaultDisposition: dis2.OE_EV_OPEN_PENDING,
    dispositions: [dis2.OE_EV_OPEN_PENDING, dis2.OE_EV_COMPLETED, dis2.OE_EV_CANCELLED],
    paymentIn: [OTHER_FEE],
    paymentOut: [OTHER_FEE],
};

const OTHER = {
    _id: new Types.ObjectId(OTHER_ID),
    label: OTHER_LABEL,
    defaultDisposition: dis2.OE_OTH_OPEN_PENDING,
    dispositions: [dis2.OE_OTH_OPEN_PENDING, dis2.OE_OTH_COMPLETED, dis2.OE_OTH_OTHER],
    paymentIn: [dis2.OT_OT_OTHER],
    paymentOut: [dis2.OT_OT_OTHER],
};

//Organizational Events
export const ORGANIZATIONAL_EVENTS = {
    _id: new Types.ObjectId(ORGANIZATIONAL_EVENTS_ID),
    icon: 'organizationalEvents',
    label: ACTIVITY_TYPE_CMC_EVENTS,
    description: 'Events organized by the CMC',
    subTypes: [BOARD_MEETING, ANNUAL_METTING, COMMITTEE_MEETING, STATEGIC_PLANNING, EVENTS, OTHER],
};
